/**
 * Keeps a requested page inside the range the current item count actually has.
 *
 * The list can shrink under the reader — a retention purge, or an error that recovers with fewer rows —
 * which leaves the requested page past the end: the pagination control unmounts, the slice comes back
 * empty, and the card renders with no rows and no way back. Clamping on read rather than correcting in
 * an effect means that frame is never painted.
 */
export const clampPage = (requestedPage: number, itemCount: number, pageSize: number): number => {
    const pageCount = Math.max(1, Math.ceil(itemCount / pageSize));

    return Math.min(Math.max(requestedPage, 1), pageCount);
};
